import React from 'react';
import styles from './Layout.module.scss';
import Header from '../organisms/header/UnaccessibleHeader';
import { useTranslation, Trans } from 'react-i18next';

/**
 * Bare shell (logo header + centered message) for the states where the app
 * cannot be shown. `messageKey` is an i18n key rather than a string so the
 * markup inside those messages (`<br/>`) still renders through `Trans`.
 */
const UnaccessibleLayout: React.FC<{ messageKey: string }> = ({ messageKey }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <Header />
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottom__unaccessibleMessage}>
          <Trans
            t={t}
            i18nKey={messageKey}
          />
        </div>
      </div>
    </div>
  );
};

export default UnaccessibleLayout;
